import { render } from "./ReservationlistView.vue?vue&type=template&id=7781c28d&scoped=true"
import script from "./ReservationlistView.vue?vue&type=script&lang=js"
export * from "./ReservationlistView.vue?vue&type=script&lang=js"

import "./ReservationlistView.vue?vue&type=style&index=0&id=7781c28d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7781c28d"]])

export default __exports__